(function () {
  'use strict';

  if (window.__gmPrivacyPreferencesOpener) return;
  window.__gmPrivacyPreferencesOpener = true;
  var pending = null;
  var focusReturn = null;
  var returnTimer = null;
  var focusGeneration = 0;
  var deadlineMs = 6000;

  function visiblePreferences() {
    var dialog = document.getElementById('shopify-pc__prefs__dialog');
    if (!dialog || !dialog.isConnected || !dialog.getClientRects().length) return false;
    var style = window.getComputedStyle(dialog);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function finish(operation, outcome) {
    if (pending !== operation) return;
    pending = null;
    window.clearTimeout(operation.deadline);
    window.clearInterval(operation.poll);
    if (operation.observer) operation.observer.disconnect();
    operation.button.disabled = false;
    operation.button.removeAttribute('aria-busy');
    if (!operation.wrapper.isConnected) return;
    var failed = outcome === 'error';
    if (operation.status) {
      operation.status.textContent = failed ? operation.wrapper.getAttribute('data-error-label') : '';
      operation.status.hidden = !failed;
    }
    if (operation.fallback) operation.fallback.hidden = !failed;
    if (outcome === 'visible') watchDialogClose(operation);
    else if (failed && operation.wasFocused && document.activeElement === document.body &&
        typeof operation.button.focus === 'function') operation.button.focus({ preventScroll: true });
  }

  function stopFocusWatch(restore) {
    cancelFocusRepair();
    if (!focusReturn) return;
    var record = focusReturn;
    focusReturn = null;
    if (record.observer) record.observer.disconnect();
    if (!restore) return;
    function returnFocus() {
      if (!pending && record.button.isConnected && !visiblePreferences() &&
          document.activeElement === document.body && typeof record.button.focus === 'function') {
        record.button.focus({ preventScroll: true });
      }
    }
    returnFocus();
    // Native/provider close cleanup can run after the DOM observer. One
    // bounded followup repairs body focus while preserving any newer focus.
    var generation = focusGeneration;
    returnTimer = window.setTimeout(function () {
      returnTimer = null;
      if (generation === focusGeneration) returnFocus();
    }, 50);
  }

  function cancelFocusRepair() {
    focusGeneration += 1;
    if (returnTimer !== null) window.clearTimeout(returnTimer);
    returnTimer = null;
  }

  function watchDialogClose(operation) {
    stopFocusWatch(false);
    var dialog = document.getElementById('shopify-pc__prefs__dialog');
    if (!dialog) return;
    // Keep the provider's own focus trap. Supply an initial target only when
    // its asynchronous render left focus on the page or our opener.
    if (document.activeElement === document.body || document.activeElement === operation.button) {
      var first = dialog.querySelector('button:not([disabled])');
      if (first && typeof first.focus === 'function') first.focus({ preventScroll: true });
    }
    if (typeof window.MutationObserver !== 'function') return;
    var record = { button: operation.button, observer: null };
    record.observer = new window.MutationObserver(function () {
      if (focusReturn !== record) return;
      if (!record.button.isConnected) return stopFocusWatch(false);
      if (!dialog.isConnected || !visiblePreferences()) stopFocusWatch(true);
    });
    focusReturn = record;
    record.observer.observe(document.documentElement, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });
  }

  function check(operation) {
    if (pending !== operation) return;
    if (!operation.wrapper.isConnected) return finish(operation, 'cancel');
    if (visiblePreferences()) return finish(operation, 'visible');
    if (operation.called) return;
    try {
      var provider = window.privacyBanner;
      if (!provider || typeof provider.showPreferences !== 'function') return;
      operation.called = true;
      Promise.resolve(provider.showPreferences()).then(function () {
        // The provider can resolve before rendering, or swallow an error.
        // Only visible public preferences UI completes this operation.
        if (pending === operation && visiblePreferences()) finish(operation, 'visible');
      }, function () { finish(operation, 'error'); });
    } catch (error) {
      finish(operation, 'error');
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && typeof target.closest === 'function' && target.closest('[data-gm-privacy-open]');
    var wrapper = button && button.closest('[data-gm-privacy-preferences]');
    if (!wrapper || event.defaultPrevented || pending) return;
    cancelFocusRepair();
    var operation = {
      wrapper: wrapper, button: button, called: false, wasFocused: document.activeElement === button,
      status: wrapper.querySelector('[data-gm-privacy-status]'),
      fallback: wrapper.querySelector('[data-gm-privacy-fallback]'),
      observer: null, poll: null, deadline: null
    };
    pending = operation;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (operation.status) {
      operation.status.textContent = wrapper.getAttribute('data-opening-label');
      operation.status.hidden = false;
    }
    if (operation.fallback) operation.fallback.hidden = true;
    operation.deadline = window.setTimeout(function () { finish(operation, 'error'); }, deadlineMs);
    operation.poll = window.setInterval(function () { check(operation); }, 100);
    if (typeof window.MutationObserver === 'function') {
      operation.observer = new window.MutationObserver(function () { check(operation); });
      operation.observer.observe(document.documentElement, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
      });
    }
    check(operation);
  });

  window.addEventListener('pagehide', function () {
    if (pending) finish(pending, 'cancel');
    stopFocusWatch(false);
  });
})();

(function () {
  'use strict';
  var id = 'gm-privacy-short-layout';
  if (document.getElementById(id)) return;
  var style = document.createElement('style');
  style.id = id;
  style.textContent = "@media (max-width: 749px) {\n  #shopify-pc__prefs__dialog button {\n    min-width: 44px !important;\n    min-height: 44px !important;\n    height: auto !important;\n    box-sizing: border-box !important;\n  }\n  #shopify-pc__prefs__dialog header h2 {\n    min-height: 44px !important;\n    padding-inline-end: 52px !important;\n    box-sizing: border-box !important;\n    overflow-wrap: anywhere !important;\n  }\n  #shopify-pc__prefs__dialog .shopify-pc__prefs__header-actions button {\n    white-space: normal !important;\n    overflow-wrap: anywhere !important;\n  }\n  #shopify-pc__prefs__dialog .shopify-pc__prefs__scrollable {\n    min-height: 80px !important;\n  }\n}\n@media (max-height: 600px) {\n  #shopify-pc__prefs__dialog {\n    position: fixed !important;\n    top: 8px !important;\n    bottom: 8px !important;\n    left: 50% !important;\n    right: auto !important;\n    width: calc(100% - 16px) !important;\n    height: auto !important;\n    min-height: 0 !important;\n    max-height: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    box-sizing: border-box !important;\n    transform: translate(-50%, 0) !important;\n    overflow-y: auto !important;\n  }\n  #shopify-pc__prefs__dialog header {\n    position: relative !important;\n    flex-direction: column !important;\n    flex-shrink: 0 !important;\n    align-items: stretch !important;\n    gap: 8px !important;\n    padding: 8px 12px !important;\n    min-width: 0 !important;\n  }\n  #shopify-pc__prefs__dialog header h2 {\n    min-height: 44px !important;\n    margin: 0 !important;\n    padding-inline-end: 52px !important;\n    box-sizing: border-box !important;\n    overflow-wrap: anywhere !important;\n  }\n  #shopify-pc__prefs__dialog button {\n    min-width: 44px !important;\n    min-height: 44px !important;\n    height: auto !important;\n    box-sizing: border-box !important;\n  }\n  #shopify-pc__prefs__dialog #shopify-pc__prefs__header-close {\n    top: 8px !important;\n    right: 12px !important;\n    margin: 0 !important;\n  }\n  #shopify-pc__prefs__dialog .shopify-pc__prefs__header-actions {\n    display: grid !important;\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 8px !important;\n    width: 100% !important;\n    min-width: 0 !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  #shopify-pc__prefs__dialog .shopify-pc__prefs__header-actions button {\n    width: 100% !important;\n    min-width: 0 !important;\n    margin: 0 !important;\n    padding: 8px !important;\n    white-space: normal !important;\n    line-height: 1.3 !important;\n    overflow-wrap: anywhere !important;\n  }\n  #shopify-pc__prefs__dialog .shopify-pc__prefs__header-actions button:nth-child(3) {\n    grid-column: 1 / -1 !important;\n  }\n  #shopify-pc__prefs__dialog .shopify-pc__prefs__scrollable {\n    flex: 1 0 80px !important;\n    min-height: 80px !important;\n    max-height: none !important;\n    padding: 8px 12px !important;\n    box-sizing: border-box !important;\n    overflow-y: auto !important;\n  }\n}\n";
  document.head.appendChild(style);
})();
